import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { GRAY_COLOR, OPEN_RATE_HIGH_COLOR, OPEN_RATE_LOW_COLOR, OPEN_RATE_MEDIUM_COLOR } from "../../../../constants/colors";


export default function OpenRateGauge({ openRate }) {
  if (openRate == null) {
    return (
      <Typography variant="body2" sx={{ color: "text.disabled" }}>
        データなし
      </Typography>
    );
  }

  if (openRate < 0) {
    return (
      <Tooltip title="集計処理中または送信数が少ないため、正確な値が算出できない場合があります" placement="top">
        <Typography variant="body2" sx={{ color: "text.secondary", cursor: "default" }}>
          集計中
        </Typography>
      </Tooltip>
    );
  }

  const clampedRate = Math.min(100, Math.max(0, openRate));
  const progressBarColor =
      clampedRate <= 30
        ? OPEN_RATE_LOW_COLOR
        : clampedRate <= 60
          ? OPEN_RATE_MEDIUM_COLOR
          : OPEN_RATE_HIGH_COLOR;

  return (
    <Box sx={{ width: 80 }}>
      <LinearProgress
        variant="determinate"
        value={clampedRate}
        sx={{
          height: 8,
          borderRadius: 9999,
          backgroundColor: GRAY_COLOR,
          "& .MuiLinearProgress-bar": {
            borderRadius: 9999,
            backgroundColor: progressBarColor,
          },
        }}
      />
    </Box>
  );
}
